import { useGlobalObjectEventListener } from './useGlobalObjectEventListener.js';

/**
 *  useWindowEventListener hook
 *
 *  A react hook to an event listener to the window
 *
 * @param {keyof WindowEventMap} eventName The event to track
 * @param {Function} callback The callback to be called on event
 * @param {ListenerOptions} listenerOptions The options to be passed to the event listener
 * @param {boolean} isLayoutEffect Should it use layout effect. Defaults to false
 * @returns {undefined}
 * @see https://rooks.vercel.app/docs/useWindowEventListener
 */
function useWindowEventListener(eventName, callback, listenerOptions = {}, isLayoutEffect = false) {
    useGlobalObjectEventListener(global.window, eventName, callback, listenerOptions, true, isLayoutEffect);
}

export { useWindowEventListener };
